import React from 'react';
import { Grid, Paper, Typography, withStyles, CircularProgress } from 'material-ui';
import { LinearProgress } from 'material-ui/Progress';

import _get from 'lodash.get';
import currencyFormatter from 'currency-formatter';
import HotelCategoryRender from './HotelCategoryRender';
import ResultCardMap from '../Results/ResultCardMap';
import classNames from 'classnames';
import OLYWebPageComponent from '../OLYWebPageComponent';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { translate } from 'react-i18next';
import moment from 'moment/moment';
import i18n from '../../services/i18n.js';
import PriceTag from '../Results/PriceTag';
import logoSource from '../../assets/hotel.svg';
import { isValidImage } from '../Utils/shared';


const styles = theme => ({
    root: {
        // width: '80%',
        // minWidth: 400,
        minWidth: '1100px',
        width: '1100px',
        margin: '0 auto',
        overflowX: 'auto',
        marginTop: '20px',
        marginBottom: '20px',
        padding: '32px 48px 32px 48px',
    },
    table: {
        minWidth: 400,
        padding: 0,
    },
    noBorder: {
        border: 0,
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    footerContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '16px',
        marginLeft: '-48px',
    },
    titleHighlighted: {
        fontWeight: 700,
    },
    rowTitle: {
        fontWeight: 700,
        fontSize: '14px',
        whiteSpace: 'nowrap',
        border: 0,
    },
    rowValue: {
        fontWeight: 400,
        fontSize: '14px',
        paddingLeft: 0,
        border: 0,
    },
    rowValueAcommodation: {
        fontWeight: 400,
        fontSize: '14px',
        paddingLeft: 0,
        border: 0,
    },
    leftRowCell: {
        verticalAlign: 'baseline',
        paddingTop: '16px',
        border: 0,
    },
    rightRowCell: {
        borderLeftColor: 'var(--primary-color)',
        borderLeftWidth: '1px',
        borderLeftStyle: 'solid',
        borderBottom: 0,
    },
    colTitle: {
        fontWeight: 700,
        fontSize: '14px',
        textTransform: 'uppercase',
        color: '#000000',
        border: 0,
        textAlign: 'center',
    },
    colValue: {
        fontWeight: 400,
        fontSize: '14px',
        border: 0,
        textAlign: 'center',
    },
    hotelTitle: {
        fontWeight: 700,
        fontSize: '18px',
        textTransform: 'uppercase',
        color: '#000000',
        paddingBottom: '14px',
        paddingLeft: '8px',
    },
    sectionTitle: {
        fontWeight: 700,
        color: 'var(--primary-color)',
        fontSize: '15px'
    },
    sectionSubtitle: {
        fontWeight: 300,
        color: 'var(--primary-color)',
        fontSize: '13px',
    },
    mainFooterWrapper: {
        marginTop: '40px',
        paddingBottom: 0,
    },
    footerTitle: {
        fontWeight: 700,
        fontSize: '14px',
        textTransform: 'uppercase',
        color: '#000000',
        border: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    agencyNameClass: {
        fontWeight: 700,
        fontSize: '24px',
        textTransform: 'uppercase',
    },
    pvp: {
        color: theme.palette.primary.contrastText,
        background: '#000000', // No lo llevo al Theme porque es el único lugar donde se usa.
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: theme.palette.secondary.main,
        textAlign: 'right'
    },
    leyendHotel: { backgroundColor: 'var(--primary-color)', color: 'var(--primary-text-color)', minHeight: '64px' }
});

function formatPrice(value) {
    return currencyFormatter.format(value, { code: 'EUR' });
}

function PriceTagRender(price, retailPrice, B2bVerPVP, props) {
    return B2bVerPVP ?
        (<div className={props.classes.price}>
            {retailPrice ?
                <span title={i18n.t('BOOKINGS.NET') + ': ' + formatPrice(price)}>
                    {formatPrice(retailPrice)}
                </span> : ''
            }
        </div>) :
        ('');
}

class HotelRoomDataPrint extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.ischild = (this.props && this.props.hasOwnProperty('ischild') && this.props.ischild);
        this.pageName = 'HotelRoomDataPrint';

        this.pageReference = '';
        let requestCode = '';
        if (_get(this.props, 'match.params.requestCode') && !props.renderHidden) {
            requestCode = this.props.match.params.requestCode;
        }

        let hotelCode = '';
        if (_get(this.props, 'match.params.hotelCode') && !props.renderHidden) {
            hotelCode = this.props.match.params.hotelCode;
        }

        let key = requestCode + '-' + hotelCode;
        let lang = 'en';
        if (this.currentUser && this.currentUser.user_detail && this.currentUser.user_detail.language) {
            lang = String(this.currentUser.user_detail.language).toLowerCase();
        }



        this.state = {
            requestCode: requestCode,
            loading: true,
            B2bVerPVP: this.currentUser.authorities.includes('B2bVerPVP'),
            selectedRooms: [],
            key: key,
            hotelCode: hotelCode,
            lang: lang,
            defaultImage: logoSource,
            validImage: false
        };
    }

    async componentDidMount() {
        await this.loadHotelRoomData();
        isValidImage(this.state.hotel.defaultImage).then(valid => {
            if (valid) {
                this.setState({ loading: false, validImage: true, defaultImage: this.state.hotel.defaultImage });
            } else {
                this.setState({ loading: false, validImage: false, defaultImage: logoSource });
            }
        });
    }

    async loadHotelRoomData() {
        let code = this.state.hotelCode;
        let rooturl = process.env.REACT_APP_API_URL;
        let selectionInformation = JSON.parse(localStorage.getItem(this.state.key));
        let requestInformation = JSON.parse(localStorage.getItem(this.state.requestCode)).request;
        let url = `${rooturl}masterdata/hotels?code=${code}&augment=true&language=${this.state.lang}`;
        requestInformation.checkOutDate = moment(requestInformation.checkInDate, 'DD/MM/YYYY').add(requestInformation.nights, 'days');
        requestInformation.kids = selectionInformation.searchOptions.kids;
        requestInformation.adults = selectionInformation.searchOptions.adults;
        const response = await fetch(url);
        const json = await response.json();
        this.setState({
            hotel: json[0],
            selectedRooms: selectionInformation.selectedRooms,
            searchOptions: requestInformation
        });
    }

    labelAvailability = value => {
        const { t } = this.props;
        const labels = {
            OK: t('COMMON.PREPAYMENT_BY_CARD'),
            RQ: t('COMMON.ON_REQUEST'),
            SS: t('COMMON.STOP_SALES'),
        };
        if (value === 'RQ') {
            return (
                <span className={this.props.classes.availability} >
                    {labels[value]}
                </span>
            );
        }
        return labels[value];
    };

    hasCoordinates = hotel => {
        return hotel && hotel.location && hotel.location.geometry && hotel.location.geometry.coordinates;
    };

    componentDidUpdate() {
        if (!this.state.loading && this.state.format === 'pdf') {
            const inputEl = document.getElementById('bonoRootPrint_' + this.state.idReserva);
            html2canvas(inputEl)
                .then((canvas) => this.generateBonoPdf(canvas, true, 'Bono_' + this.state.idReserva))
                .catch((err) => console.error('there was an error while saving Bono: ' + err));
        }
    }

    generateBonoPdf(canvas, shouldSave, fileName) {
        let doc = new jsPDF('p', 'mm', 'a4');

        const width = 200;
        const height = 200;
        const imgData = canvas.toDataURL('image/png');

        doc.addImage(imgData, 'JPEG', 0, 0, width, height, undefined, 'FAST');
        if (shouldSave) {
            const blob = doc.output('blob', '_blank');
            const isEdge = window.navigator && window.navigator.msSaveOrOpenBlob;
            const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
            const isSafari = navigator.userAgent.indexOf('Safari') > -1;
            if (isEdge) {
                window.navigator.msSaveOrOpenBlob(blob, fileName + '.pdf');
            } else if (isChrome) {
                window.location.href = URL.createObjectURL(blob);
            } else if (isSafari) {
                doc.output('datauri');
            } else {
                doc.output('datauri');
            }
        }
    }
    getFacilityName(facility, lang) {
        return facility['description_' + lang] || facility.description;
    }

    render() {
        const { classes, t } = this.props;
        const { hotel, selectedRooms, searchOptions, defaultImage } = this.state;
        let agency = {};
        let lang = process.env.REACT_APP_DEFAULT_LANGUAGE;
        agency = this.currentUser.agency;

        let hasVoucherImage = agency && (agency.voucherImage || agency.logoImage);
        const eleid = 'bonoRootPrint_' + this.state.idReserva;
        return this.state.loading && !hotel ?
            <div>
                <LinearProgress className="cmsProgressBar" variant='indeterminate' />
            </div>
            :
            <Paper id={eleid} className={classNames(classes.root, 'bonoRootPrint')} style={{ textAlign: 'left' }} elevation={0}>
                <Grid container>
                    {/* AGENCY LOGO */}
                    <Grid container item xs={12}>
                        <div className={classes.imageContainer} style={{ margin: '0 auto', marginTop: '16px' }}>
                            {hasVoucherImage ? (
                                <img
                                    src={agency.voucherImage || agency.logoImage}
                                    alt="logo"
                                    style={{ height: '64px' }}
                                />
                            ) : (
                                    ''
                                )}
                        </div>
                    </Grid>

                    {/*
                                SEPARATOR -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={3} className={classes.leftRowCell}>
                            <Typography className={classes.sectionTitle}>{t('HOME.DESTINATION-LABEL')}</Typography>
                            <Typography className={classes.sectionSubtitle}>{t('BOOKING_DETAIL.BOOKING_DETAIL')}</Typography>
                        </Grid>
                        <Grid item xs={9} className={classes.rightRowCell} style={{ backgroundColor: '#f5f5f5' }}>
                            <Grid container item xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('HOME.DESTINATION-LABEL') + ':'}
                                </Grid>
                                <Grid item xs={7} className={classes.rowValueAcommodation}>
                                    {hotel.town.name} - {hotel.state.name}
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('COMMON.CHECK_IN') + ':'}
                                </Grid>
                                <Grid item xs={7} className={classes.rowValueAcommodation}>
                                    {searchOptions.checkInDate}
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('COMMON.CHECK_OUT') + ':'}
                                </Grid>
                                <Grid item xs={7} className={classes.rowValueAcommodation}>
                                    {moment(searchOptions.checkOutDate).format('DD/MM/YYYY')}
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('COMMON.NIGHTS') + ':'}
                                </Grid>
                                <Grid item xs={7} className={classes.rowValueAcommodation}>
                                    {searchOptions.nights}
                                </Grid>
                            </Grid>
                            <Grid container item xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('HOME.PASSENGERS') + ':'}
                                </Grid>
                                <Grid item xs={7} className={classes.rowValueAcommodation}>
                                    {t('COMMON.ADULT', { count: searchOptions.adults })} - {t('COMMON.KID', { count: searchOptions.kids })}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*
                                SEPARATOR -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>

                    {/*
                                DATOS ALOJAMIENTO
                            */}
                    <Grid container item xs={12}>
                        <Grid item xs={3} className={classes.leftRowCell}>
                            <Typography className={classes.sectionTitle}>{t('VOUCHER.HOTEL_INFORMATION')}</Typography>
                            <Typography className={classes.sectionSubtitle}>{t('RESULT_CARD.TAB_LOCATION')} & {t('RESULT_CARD.TAB_SERVICES')}</Typography>
                        </Grid>
                        <Grid container xs={9} className={classes.rightRowCell} style={{ marginLeft: 0 }}>
                            <Grid container item xs={12}>
                                <Grid container item xs={12}>
                                    <div className={classNames(classes.hotelTitle, classes.noBorder)}>
                                        <div style={{ marginRight: '16px', float: 'left' }}>
                                            {hotel.name}
                                        </div>
                                        <HotelCategoryRender
                                            category={hotel.category ? hotel.category : null}
                                        />
                                    </div>
                                </Grid>
                                <Grid container item={12}>
                                    <Grid item xs={6}>
                                        {
                                            this.state.loading ?
                                                <div style={{ width: '380px', height: '240px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <CircularProgress className="cmsProgressBar" />
                                                </div> :
                                                <img src={defaultImage} style={{ width: '380px', height: '240px' }} alt={hotel.name} />
                                        }
                                        <p><b>{t('VOUCHER.HOTEL_INFORMATION')}</b></p>
                                        <Typography dangerouslySetInnerHTML={{
                                            __html:
                                                hotel.locationDescription.split('\r\n').join('<br />')
                                        }}>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ResultCardMap
                                            width="420"
                                            height="240"
                                            center={hotel.location}
                                            zoom={11}
                                        />
                                        <br />
                                        <br />
                                        <b>{t('CONFIRM_BOOKING.SERVICES')}</b>
                                        <ul style={{ paddingLeft: '15px' }}>
                                            {
                                                hotel.facilities.slice(0, 10).map((service, idx) => {
                                                    return (
                                                        <li>
                                                            {this.getFacilityName(service, lang)}
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*
                                SEPARATOR -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>

                    {/*
                                OBSERVACIONES DEL ALOJAMIENTO -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid container item xs={12}>
                        <Grid item xs={3} className={classes.leftRowCell}>
                            <Typography className={classes.sectionTitle}>{t('COMMON.ROOMS')}</Typography>
                            <Typography className={classes.sectionSubtitle}>{t('COMMON.ROOMS_SELECTED')}</Typography>
                        </Grid>
                        <Grid
                            item xs={9}
                            className={classes.rightRowCell}
                            style={{
                                backgroundColor: '#f5f5f5',
                            }}>

                            {selectedRooms.map((room, idx) => {
                                return (
                                    <div key={idx}>
                                        <Grid container direction="row" justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography
                                                    style={{
                                                        fontSize: '16px',
                                                        minHeight: '33px',
                                                        paddingTop: (idx > 0) ? '16px' : ''
                                                    }}>
                                                    <b>{t('RESULT_CARD.ROOM_POS', { pos: idx + 1 })}</b> - {room.service} - {room.description}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{
                                                    fontSize: '16px',
                                                    minHeight: '33px',
                                                    paddingTop: (idx > 0) ? '16px' : ''
                                                }}>
                                                    {room.refundable ? '' : t('COMMON.NO_REFUNDABLE')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Grid container direction="row" justify="flex-end" alignItems="center">
                                                    <Grid item>
                                                        {this.state.B2bVerPVP ?
                                                            <div className="circle">PVP</div> : ''
                                                        }
                                                    </Grid>
                                                    <Grid item>
                                                        <PriceTag
                                                            B2bVerPVP={this.state.B2bVerPVP}
                                                            pvp={room.pvpCost}
                                                            price={room.price}
                                                            showNetPrice={this.state.B2bVerPVP}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {selectedRooms.length - 1 === idx ? '' : <div style={{ borderBottom: '1px solid #e5e5e5' }} />}
                                    </div>
                                );
                            })}

                        </Grid>
                    </Grid>


                    {/*
                                SEPARATOR -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>
                    {/* LEYENDA DEL HOTEL */}
                    <Grid container xs={12} alignItems="center" className={classes.leyendHotel}>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={9}>{t('COMMON.PRICE_WARNING')}</Grid>
                    </Grid>

                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>
                    {/*
                                DATOS AGENCIA
                            */}
                    <Grid container xs={12}>
                        <Grid item xs={3} className={classes.leftRowCell}>
                            <Typography className={classes.sectionTitle}>{t('AGENCY.AGENCY')}</Typography>
                            <Typography className={classes.sectionSubtitle}>{t('AGENCY.DETAILS')}</Typography>
                        </Grid>
                        <Grid item xs={9} className={classes.rightRowCell}>
                            <Grid container xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('AGENCY.AGENCY') + ':'}
                                </Grid>
                                <Grid item xs={10} className={classes.rowValueAcommodation}>
                                    {agency.name}
                                </Grid>
                            </Grid>
                            {/** Address no va **/}
                            {/* 
                                    <Grid container item xs={12}>
                                        <Grid item xs={2} className={classes.rowTitle}>
                                            {t('AGENCY.ADDRESS') + ':'}
                                        </Grid>
                                        <Grid item xs={7} className={classes.rowValueAcommodation}>
                                            {agency.address}
                                        </Grid>
                                    </Grid>
                                    */}
                            <Grid container xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('AGENCY.PHONE') + ':'}
                                </Grid>
                                <Grid item xs={10} className={classes.rowValueAcommodation}>
                                    {agency.telephone} / {agency.fax}
                                </Grid>
                            </Grid>
                            <Grid container xs={12}>
                                <Grid item xs={2} className={classes.rowTitle}>
                                    {t('AGENCY.EMAIL') + ':'}
                                </Grid>
                                <Grid item xs={10} className={classes.rowValueAcommodation}>
                                    {agency.email}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*
                                SEPARATOR -> hacky workaround to avoid extra custom styling for spacing between rows
                            */}
                    <Grid item xs={12} className={'bonoSeparator'}>
                        <div style={{ height: '15px' }} />
                    </Grid>
                </Grid>
            </Paper>;
    }
}

export default translate('translations')(withStyles(styles)(HotelRoomDataPrint));



// WEBPACK FOOTER //
// ./src/components/Reservation/HotelRoomDataPrint.js